export function parseJwt(token: string) {
	if (!token) {
		return {};
	}
	const base64Url = token.split('.')[1];
	const jsonPayload = decodeURIComponent(atob(base64Url));
	return JSON.parse(jsonPayload);
}
